import { render, staticRenderFns } from "./Notification.html?vue&type=template&id=2efece80&external"
import script from "./Notification.ts?vue&type=script&lang=ts&external"
export * from "./Notification.ts?vue&type=script&lang=ts&external"
import style0 from "./Notification.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports